import { createContext } from 'react'

const UserContext = createContext({
    userId: null,
    email: null
});

export default UserContext